/**
 * 新控车指令 → 操作日志 instruction_type_code（远程控车 BUSINESS_* 类型）
 */
export const BUSINESS_INSTRUCTION_TYPE_CODES = [
  'BUSINESS_CANCEL_QUEUE',
  'BUSINESS_BARRIER_PASSAGE',
  'BUSINESS_PHYSICAL_RECOVERY',
  'BUSINESS_PHYSICAL_RECOVERY_ABORT',
  'BUSINESS_PHYSICAL_RECOVERY_ENVIRONMENT_EDIT_CLEAR',
  'BUSINESS_LANE_CHANGE',
  'BUSINESS_ONE_KEY_MOVE',
  'BUSINESS_LANE_KEEPING_ENABLE',
  'BUSINESS_LANE_KEEPING_DISABLE',
  'BUSINESS_PROCEED_THROUGH_TF_LIGHT',
] as const;

export type BusinessInstructionTypeCode =
  (typeof BUSINESS_INSTRUCTION_TYPE_CODES)[number];

/** instruction_type_code → 中文说明 */
export const BUSINESS_INSTRUCTION_TYPE_LABEL: Record<
  BusinessInstructionTypeCode,
  string
> = {
  BUSINESS_CANCEL_QUEUE: '取消排队',
  BUSINESS_BARRIER_PASSAGE: '通过抬杆',
  BUSINESS_PHYSICAL_RECOVERY: '开始物理脱困',
  BUSINESS_PHYSICAL_RECOVERY_ABORT: '中止物理脱困',
  BUSINESS_PHYSICAL_RECOVERY_ENVIRONMENT_EDIT_CLEAR:
    'WS 断连清理物理脱困环境编辑',
  BUSINESS_LANE_CHANGE: '变道',
  BUSINESS_ONE_KEY_MOVE: '一键挪车',
  BUSINESS_LANE_KEEPING_ENABLE: '车道保持开启',
  BUSINESS_LANE_KEEPING_DISABLE: '车道保持关闭',
  BUSINESS_PROCEED_THROUGH_TF_LIGHT: '红绿灯可通行',
};
